import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Button, { ButtonColor, ButtonSize } from '../../buttons/Button';
import css from './GlobalNavModalMenu.module.scss';

interface Props extends React.HTMLProps<{}> {
  handleClose: () => void;
}

class GlobalNavModalMenu extends React.PureComponent<
  Props & InjectedIntlProps
> {
  public render() {
    const { intl, className } = this.props;
    const intlPref = 'components.common.layouts.globalHeader.';

    return (
      <nav className={classNames(css.GlobalNavModalMenu, className)}>
        <Button
          buttonColor={ButtonColor.White}
          buttonSize={ButtonSize.Large}
          className={css.GlobalNavModalMenu__Button}
          isGhost={true}
          tag="a"
          onClick={() =>
            (location.href = `/login?return_to=${location.pathname}`)
          }
        >
          {intl.formatMessage({ id: intlPref + 'buttons.signin' })}
        </Button>
        <Button
          buttonColor={ButtonColor.White}
          buttonSize={ButtonSize.Large}
          className={css.GlobalNavModalMenu__Button}
          isGhost={true}
          href="https://stores.jp/reserve"
        >
          {intl.formatMessage({ id: intlPref + 'links.business' })}
        </Button>
        <svg
          className={css.GlobalNavModalMenu__Close}
          onClick={this.props.handleClose}
        >
          <use xlinkHref="#close" />
        </svg>
      </nav>
    );
  }
}

export default injectIntl(GlobalNavModalMenu);
